<script setup lang="ts">
import InfoPersonaliSezione from '@/features/account/components/InfoPersonaliSezione.vue';
import ImmagineProfiloSezione from '@/features/account/components/ImmagineProfiloSezione.vue';
import CambioPasswordSezione from '@/features/account/components/CambioPasswordSezione.vue';
import DuefaSezione from '@/features/account/components/DuefaSezione.vue';
import ApiKeySezione from '@/features/account/components/ApiKeySezione.vue';
import NotifichePreferenzeSezione from '@/features/account/components/NotifichePreferenzeSezione.vue';
import RiepilogoPreferenzeSezione from '@/features/account/components/RiepilogoPreferenzeSezione.vue';
import TemaPreferenzeSezione from '@/features/account/components/TemaPreferenzeSezione.vue';

// Rotta protetta: niente `pubblica`, quindi vive dentro l'AppShell.
definePage({
  meta: { titolo: 'Account' },
});
</script>

<template>
  <div class="flex max-w-5xl flex-col gap-6">
    <header>
      <p class="text-xs font-semibold tracking-[0.08em] text-ink-muted uppercase">Impostazioni</p>
      <h1 class="mt-1 font-display text-[33px] leading-[1.07] font-semibold">Account</h1>
    </header>

    <InfoPersonaliSezione />
    <ImmagineProfiloSezione />
    <TemaPreferenzeSezione />
    <CambioPasswordSezione />
    <DuefaSezione />
    <NotifichePreferenzeSezione />
    <RiepilogoPreferenzeSezione />
    <ApiKeySezione />
  </div>
</template>
